import React from 'react';
import {Link, Redirect} from 'react-router-dom'
import Calendar from 'react-calendar';
import _ from 'underscore'
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles';
import indigo from "@material-ui/core/colors/indigo";
import ApiFetcher from "../../ApiFetcher";
import Utility from "../../Utility";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    generalButton: {
        margin: 'auto',
        width: '80%',
    },
    circularProgressRoot: {
        margin: theme.spacing.unit,
    },
    dialogCircularProgressRoot: {
        margin: 'auto',
    },
    tab: {
        textTransform: 'initial',
        backgroundColor: indigo['A100'],
    },
    calendar: {
        margin: 'auto',
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    calenderDisplayNone: {
        display: 'none'
    },
    textField: {
        margin: theme.spacing.unit,
    },
    nonDispatchableNum: {
        backgroundColor: '#2196f3',
        margin: 'auto',
        width: '50%',
        height: '50%',
        borderRadius: '50%',
        color: 'white'
    },
    errorMessage: {
        color: 'red'
    },
    tileEnable: {
        color: 'black'
    },
    tileDisable: {
        color: 'gray'
    }
});

export class SetNonDispatchableNum extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            pompSpecs: [],
            calendars: [],
            pompSpecId: null,
            activeDate: Utility.getTomorrowDate(),
            dialogOpen: false,
            dialogNonDispatchableNum: 0,
            updateError: [],
            isWaitGetPompSpecs: true,
            isWaitGetCalenders: true,
            isWaitUpdateNonDispatchableNum: false,
        };

        this.createNonDispatchableNum = this.createNonDispatchableNum.bind(this);
        this.findCalenderDispatchNum = this.findCalenderDispatchNum.bind(this);
        this.getCalendars = this.getCalendars.bind(this);
        this.handleGetCalenderResponse = this.handleGetCalenderResponse.bind(this);
        this.handleGetSelectItemPompSpecResponse = this.handleGetSelectItemPompSpecResponse.bind(this);
        this.handleUpdateNonDispatchableNumResponse = this.handleUpdateNonDispatchableNumResponse.bind(this);
        this.onActiveDateOnChange = this.onActiveDateOnChange.bind(this);
        this.onChangeDialogNonDispatchableNum = this.onChangeDialogNonDispatchableNum.bind(this);
        this.onChangePompSpecId = this.onChangePompSpecId.bind(this);
        this.onClickDay = this.onClickDay.bind(this);
        this.onClickUpdateNonDispatchableNum = this.onClickUpdateNonDispatchableNum.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.getTileClassName = this.getTileClassName.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('貸出不可台数設定画面');
        }
    }

    componentDidMount(){
        ApiFetcher.getSelectItemPompSpec(this.props.cookies.get('token'), this.handleGetSelectItemPompSpecResponse);
    }

    createNonDispatchableNum({date}){
        // 今日以前は設定不可.
        if(Utility.isDateAEqualOrBeforeB(date, new Date())){
            return <div>×</div>;
        }
        return <div className={this.props.classes.nonDispatchableNum}>{this.findCalenderDispatchNum(date)}</div>;
    }

    findCalenderDispatchNum(date){
        // 貸出不可設定のカレンダー情報が存在していればその台数を返却.
        // 存在していなければ0を返却.
        let nonDispatchableNum = 0;
        let object = _.findWhere(this.state.calendars, {calendarDate: Utility.formatDate(date, 'yyyyMMdd')});
        if(object !== undefined){
            nonDispatchableNum = object.dispatchNum;
        }
        return nonDispatchableNum;
    }

    getCalendars(){
        this.setState({isWaitGetCalenders: true}, () => {
            ApiFetcher.getCalendarsForSetNonDispatchableNum(
                this.props.cookies.get('token'),
                this.props.cookies.get('id'),
                Utility.getFirstDate(this.state.activeDate),
                Utility.getLastDate(this.state.activeDate),
                this.state.pompSpecId,
                this.handleGetCalenderResponse
            );
        });
    }

    handleGetCalenderResponse(responseJson){
        if(responseJson.message === null || responseJson.message === ""){
            this.setState({calendars: responseJson.result.Calendars});
        }
        else{
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            // + リクエストパラメータが不正(操作的には不可能なのでありえない)
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }
        this.setState({isWaitGetCalenders: false}); // 応答待ちフラグ起点でカレンダーの再描画が実行されるため, calendarsをセットした後で応答待ちフラグを解除する.
    }

    handleGetSelectItemPompSpecResponse(responseJson){
        // pompSpecsより後にpompSpecIdを設定するとTabsでWarningが出る.
        // setStateによるstateへ値の反映が非同期のため,反映完了後にgetCalendarsをコールする.
        this.setState({
            isWaitGetPompSpecs: false,
            pompSpecId: responseJson.result.pompSpecs[0].objectId,
            pompSpecs: responseJson.result.pompSpecs
        }, this.getCalendars);
    }

    handleUpdateNonDispatchableNumResponse(responseJson){
        this.setState({isWaitUpdateNonDispatchableNum: false});
        if(responseJson.message === null || responseJson.message === ""){
            alert('貸出不可台数を更新しました。');
            this.onDialogClose();
            this.getCalendars(); // 表示更新.
        }
        else{
            // 想定されるエラーは以下の通り.
            // + トークン期限切れ
            // + リクエストパラメータが不正
            this.setState({updateError: responseJson.message});
        }
    }

    onActiveDateOnChange({activeStartDate}){
        this.setState({activeDate: activeStartDate}, this.getCalendars); // setStateによるstateへ値の反映が非同期のため,反映完了後にgetCalendarsをコールする.
    }

    onChangeDialogNonDispatchableNum(event){
        this.setState({dialogNonDispatchableNum: event.target.value});
    }

    onChangePompSpecId(event, value){
        this.setState({pompSpecId: value}, this.getCalendars); // setStateによるstateへ値の反映が非同期のため,反映完了後にgetCalendarsをコールする.
    }

    onClickDay(date){
        this.setState({activeDate: date});
        this.setState({dialogOpen: true});
        this.setState({dialogNonDispatchableNum: this.findCalenderDispatchNum(date)});
    }

    onClickUpdateNonDispatchableNum(){
        this.setState({isWaitUpdateNonDispatchableNum: true}, () => {
            ApiFetcher.putCalendars(
                this.props.cookies.get('token'),
                this.state.activeDate,
                this.props.cookies.get('id'),
                this.state.pompSpecId,
                this.state.dialogNonDispatchableNum,
                this.handleUpdateNonDispatchableNumResponse
            );
        });
    }

    onDialogClose(){
        this.setState({updateError: []}); // ダイアログを閉じたらエラーメッセージはリセット.
        this.setState({dialogOpen: false});
    }

    showPompSpecTab(){
        if(this.state.isWaitGetPompSpecs){
            // API応答待ち表示.
            return (
                <div className={this.props.classes.circularProgressRoot}>
                    <CircularProgress/>
                </div>
            );
        }
        else{
            return (
                <AppBar position="static">
                    <Tabs value={this.state.pompSpecId} onChange={this.onChangePompSpecId} fullWidth={true}>
                        {this.state.pompSpecs.map((row, i) =>{
                            return (<Tab key={i} className={this.props.classes.tab} label={row.name} value={row.objectId}/>);
                        })}
                    </Tabs>
                </AppBar>
            );
        }
    }

    getTileClassName({date}){
        return date <= new Date() ? this.props.classes.tileDisable : this.props.classes.tileEnable;
    }

    showCalendar(){
        return (
            <div>
                {
                    this.state.isWaitGetCalenders === true &&
                    <div className={this.props.classes.circularProgressRoot}>
                        <CircularProgress/>
                    </div>
                }
                <Calendar
                    activeStartDate={this.state.activeDate}
                    className={
                        this.props.classes.calendar
                        + ' ' +
                        (this.state.isWaitGetCalenders ? this.props.classes.calenderDisplayNone : '')
                    }
                    minDate={Utility.getTomorrowDate()} // 今日以前は変更不可.
                    showNeighboringMonth={false}
                    minDetail="month"
                    prev2Label={null}
                    next2Label={null}
                    calendarType="US"
                    locale="JP"
                    tileClassName={this.getTileClassName}
                    onClickDay={this.onClickDay}
                    onActiveDateChange={this.onActiveDateOnChange}
                    tileContent={this.state.isWaitGetCalenders ? null : this.createNonDispatchableNum}
                />
            </div>
        );
    }

    static convertErrorMessagePropertyName(propertyName){
        if(propertyName === 'calendarDate'){
            return 'カレンダー日付:';
        }
        else if(propertyName === 'matchingId'){
            return '協力会社ID:';
        }
        else if(propertyName === 'pompSpecId'){
            return 'ポンプ仕様ID:';
        }
        else if(propertyName === 'dispatchNum'){
            return '貸出不可台数:';
        }
        else{
            return '';
        }
    }

    render(){
        // 協力会社アカウントでない場合はアクセス不可のためトップへリダイレクト.
        if(!Utility.isBusinessPartnerRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        return (
            <div className={this.props.classes.root}>
                {this.showPompSpecTab()}
                {this.showCalendar()}
                <div>
                    <Button
                        component={(props) => <Link to={this.props.backPath} {...props}/>}
                        variant="contained"
                        color="primary"
                        className={this.props.classes.generalButton}
                    >
                        トップ画面へ戻る
                    </Button>
                </div>
                <Dialog open={this.state.dialogOpen} onClose={this.onDialogClose}>
                    <div>
                        <DialogTitle>{Utility.formatDate(this.state.activeDate, 'yyyy/MM/dd')}</DialogTitle>
                        <DialogContent>
                            <div>
                                {this.state.updateError.map((row, i) =>{
                                    return (
                                        <div key={i} className={this.props.classes.errorMessage}>
                                            {SetNonDispatchableNum.convertErrorMessagePropertyName(row.propertyName)}{row.errorMessage}
                                        </div>
                                    )
                                })}
                            </div>
                            <TextField
                                className={this.props.classes.textField}
                                label="貸出不可台数"
                                type="number"
                                value={this.state.dialogNonDispatchableNum}
                                onChange={this.onChangeDialogNonDispatchableNum}
                                variant="outlined"
                            />
                        </DialogContent>
                        {
                            this.state.isWaitUpdateNonDispatchableNum === true &&
                            <DialogActions>
                                <div className={this.props.classes.dialogCircularProgressRoot}>
                                    <CircularProgress/>
                                </div>
                            </DialogActions>
                        }
                        {
                            this.state.isWaitUpdateNonDispatchableNum === false &&
                            <DialogActions>
                                <Button onClick={this.onDialogClose} hidden={this.state.isWaitUpdateNonDispatchableNum} variant="contained" color="primary">キャンセル</Button>
                                <Button onClick={this.onClickUpdateNonDispatchableNum} hidden={this.state.isWaitUpdateNonDispatchableNum} variant="contained" color="primary">更新</Button>
                            </DialogActions>
                        }
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(SetNonDispatchableNum);
